import React from "react";
import "./Why_Choose_Us.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Why_Choose_Us = () => {
  const data = [
    "20+ years of experience in residential and commercial interiors",
    "Projects across Pune, Mumbai, Thane, Nashik, Satara, Sangamner & Bhigwan",
    "End-to-end services: design, execution & finishing",
    "Specialized teams for carpentry, painting, electrification, plumbing & more",
    "On-time project delivery without compromising on quality",
    "Flexible to work with your budget and requirements",
  ];

  return (
    <section className="Why_Choose_Us">
      <div className="container">
        <Common_Title pageTitle="Why Choose" boxText=" Tech Interiors and Designers? " />

        <div className="features_div">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-sm-6 col-6">
                  <div className="details_card">
                    <img
                      src="/assets/images/services/key_elements/checked.png"
                      className="point_img"
                    />

                    <div className="content_div">
                      <p className="descn">{item}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
